import { atom } from 'recoil';
import type { OpenIntent } from './resolveOpenIntent';

/**
 * A request to open a patient from the database once the worklist is shown,
 * set by `useCloseAndOpenPatient` just before it unloads the loaded patient
 * and navigates there. {@link OpenInViewerDownloader} consumes-and-clears it
 * on mount and runs the standard open flow — there is no parallel load path.
 */
export type PendingReopenRequest = {
    /** Connector patient row GUID to open. */
    patientId: string;
    /** What to open it as; absent opens the whole patient. */
    intent?: OpenIntent;
};

export const pendingReopenRequestState = atom<PendingReopenRequest | null>({
    key: 'pendingReopenRequest',
    default: null,
});
